export const getHiddenMask = (mask) => mask.replace(/9/g, '0').replace(/a/g, 'b').replace(/\*/g, '&');
